import { h, FunctionComponent } from 'preact';
import { LoginSearchTab } from '../LoginModal.styles';
import { TabContent } from '../../Tabs/Tabs.styles';

export interface LoginTabProps {
  id: string | number;
  children?: preact.ComponentChildren;
}

/**
 * LoginModal-specific Tab component
 * Uses LoginSearchTab styled component with dynamic font size and padding
 * Maintains same API as base Tab component
 */
export const LoginTab: FunctionComponent<LoginTabProps> = ({
  id,
  children,
}) => {
  return (
    <LoginSearchTab data-key={id}>
      <TabContent title={children}>{children}</TabContent>
    </LoginSearchTab>
  );
};
